export default __webpack_public_path__ + "static/media/matkaTimerWheelBg.5dd88270.svg";